import React from "react";
import { useNavigate } from "react-router-dom";
import DropdownButton from "./DropdownButton";

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <nav className="bg-[#051E1C] h-[6.25rem] pr-[3.125rem] flex items-center justify-between">
      {/* Logo */}
      <div
        onClick={() => navigate("/dashboard")}
        className="cursor-pointer"
      >
        <img src="assets/LOGO.svg" alt="Logo" className="w-[2.4375rem] h-[3.9609rem] mt-[1.3125rem] ml-[3.125rem] mb-[0.9375rem]" />
      </div>

      {/* Dropdown */}
      <div>
        <DropdownButton />
      </div>
    </nav>
  );
};

export default Navbar;